export type HeaderType = Record<string, string> | Headers | string[][];

const toHttpHeaders = (headers?: HeaderType): Map<string, string> => {
  const hs = new Map<string, string>();
  if (headers instanceof Headers) {
    headers.forEach((value, key) => hs.set(key, value));
  } else if (Array.isArray(headers)) {
    headers.forEach(([key, value]) => hs.set(key, value));
  } else if (headers) {
    Object.entries(headers).forEach(([k, v]) => hs.set(k, v));
  }
  return hs;
};
export default toHttpHeaders;
